
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/IssueProjectsList/IssueProjectsList.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./IssueProjectsList.html');
        
        var script = require('./IssueProjectsList.ts').default;
        module.exports = require('./IssueProjectsList.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    